// extracted by mini-css-extract-plugin
module.exports = {"root":"_1kIkz","active":"_235XR"};